import React, { useEffect, useState } from "react";
import styles from "./styles/InputColor.module.css";
import Button from "../button/Button";
import { useTranslation } from "react-i18next";

/**
 * Color picker component
 * will set the default color on clicking the default button
 */
const InputColor = ({
    label, // {String} - The label text for the input
    inputId, // {String} - The ID of the input element
    inputValue, // {String} - The value of the input
    handleChangeFunction, // {Function} - The function to handle input changes
    defaultColor, // {String} - The default color value
}) => {
    const { t } = useTranslation();

    const [currentColor, setCurrentColor] = useState();

    // Update the selected current color state with the selected color
    useEffect(() => {
        setCurrentColor(inputValue);
    }, [inputValue]);

    /**
     * Set the color to the default color
     */
    const handleDefaultColorClick = () => {
        setCurrentColor(defaultColor);
        handleChangeFunction({
            target: { name: inputId, value: defaultColor },
        });
    };
    return (
        <div className={`${styles.input_container} flex-container`}>
            <label className={`${styles.input_label}`} htmlFor={inputId}>
                {label}:
            </label>
            <input
                className={`${styles.input_element} 
                
                `}
                type="color"
                name={inputId}
                id={inputId}
                value={currentColor ?? "#FFFFFF"}
                onChange={handleChangeFunction}
            />
            <div className={`${styles.default_button} flex-container`}>
                <Button
                    type={"button"}
                    size={"small"}
                    body={t(`default`)}
                    onClickFuction={handleDefaultColorClick}
                />
            </div>
        </div>
    );
};

export default InputColor;
